import React from 'react';

// Main admin pages
export const AdminIndex = React.lazy(() => import('../../pages/admin/AdminIndex'));
export const AdminMetrics = React.lazy(() => import('../../pages/admin/AdminMetrics'));
export const AdminMetricsAnalysisPage = React.lazy(() => import('../../pages/admin/AdminMetricsAnalysisPage'));
export const AdminTransactionsPage = React.lazy(() => import('../../pages/admin/TransactionsPage'));

// AI pages
export const AdminAIPage = React.lazy(() => import('../../pages/admin/ai/AdminAIPage'));

// Newsletter pages
export const AdminSendNewsletterPage = React.lazy(() => import('../../pages/admin/newsletter/AdminSendNewsletterPage'));
export const AdminScheduledNewslettersPage = React.lazy(() => import('../../pages/admin/newsletter/AdminScheduledNewslettersPage'));
export const AdminListNewslettersPage = React.lazy(() => import('../../pages/admin/newsletter/AdminListNewslettersPage'));
export const AdminAddToNewsletterPage = React.lazy(() => import('../../pages/admin/newsletter/AdminAddToNewsletterPage'));
export const AdminNewsletterCampaignsStatisticsPage = React.lazy(() => import('../../pages/admin/newsletter/AdminNewsletterCampaignsStatisticsPage'));
export const AdminNewsletterFollowUpsStatisticsPage = React.lazy(() => import('../../pages/admin/newsletter/AdminNewsletterFollowUpsStatisticsPage'));
export const AdminSmsCampaignsStatisticsPage = React.lazy(() => import('../../pages/admin/newsletter/AdminSmsCampaignsStatisticsPage'));

// Dynamic newsletter management pages
export const AdminMailingListsPage = React.lazy(() => import('../../pages/admin/newsletter/AdminMailingListsPage'));
export const AdminTagsPage = React.lazy(() => import('../../pages/admin/newsletter/AdminTagsPage'));
export const AdminSegmentsPage = React.lazy(() => import('../../pages/admin/newsletter/AdminSegmentsPage'));
export const AdminAutomationsPage = React.lazy(() => import('../../pages/admin/newsletter/AdminAutomationsPage'));
export const AdminEmailTemplatesPage = React.lazy(() => import('../../pages/admin/newsletter/AdminEmailTemplatesPage'));

// Blog pages
export const AdminBlogPage = React.lazy(() => import('../../pages/admin/blog/AdminBlogPage'));
export const AdminCreateOrEditBlogArticlePage = React.lazy(() => import('../../pages/admin/blog/AdminCreateOrEditBlogArticlePage'));

// Feedback and diagnostic pages
export const AdminFeedbackPage = React.lazy(() => import('../../pages/admin/feedback/AdminFeedbackPage'));
export const AdminDiagnosticPage = React.lazy(() => import('../../pages/admin/diagnostic/AdminDiagnosticPage'));

// Traces
export const AdminTracesPage = React.lazy(() => import('../../pages/admin/trace/AdminTracesPage'));

// KED pages
export const AdminKedExperimentPage = React.lazy(() => import('../../pages/admin/ked/AdminKedExperimentPage'));
export const AdminKedOfferPage = React.lazy(() => import('../../pages/admin/ked/AdminKedOfferPage'));
export const AdminKedMeetingsPage = React.lazy(() => import('../../pages/admin/ked/AdminKedMeetingsPage'));
export const AdminCreateOrEditKedMeetingPage = React.lazy(() => import('../../pages/admin/ked/AdminCreateOrEditKedMeetingPage'));
export const AdminCourseUsersPage = React.lazy(() => import('../../pages/admin/ked/AdminCourseUsersPage'));
export const AdminKedVerificationPage = React.lazy(() => import('../../pages/admin/ked/AdminKedVerificationPage'));
export const AdminKedCrmPage = React.lazy(() => import('../../pages/admin/ked/AdminKedCrmPage'));
export const AdminKedAdsResultsPage = React.lazy(() => import('../../pages/admin/ked/AdminKedAdsResultsPage'));
export const AdminKedRedirect = React.lazy(() => import('../../pages/admin/ked/AdminKedRedirect'));

// Exercise configuration pages
export const AdminCreateOrEditExercisePage = React.lazy(() => import('../../pages/admin/exercise/AdminCreateOrEditExercisePage'));
export const AdminSubjectConfigurationPage = React.lazy(() => import('../../pages/admin/exercise/AdminSubjectConfigurationPage'));

// Course gamification configuration
export const AdminCourseGamificationConfigPage = React.lazy(() => import('../../pages/admin/course-gamification/AdminCourseGamificationConfigPage'));

// Referrals pages
export const AdminReferralsPage = React.lazy(() => import('../../pages/admin/referrals/AdminReferralsPage'));

// Webinar Chat
export const AdminWebinarChatPage = React.lazy(() => import('../../pages/admin/webinar-chat/AdminWebinarChatPage'));